<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'layout-statistiques'
}
</script>

<style scoped></style>
